<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card" header="Setting Livelli" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Id Setting</label>
                        <b-form-select v-model="jsonDataSettingLivelli.idSetting" :options="settingOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione</label>
                        <b-form-input v-model="jsonDataSettingLivelli.descrizione"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsasettinglivelli",
            pathResourceSetting: "/rsasettings",
            id: "-1",
            jsonDataSettingLivelli: { idSetting: null, descrizione: "" },
            settingOptions: [{ value: null, text: "Seleziona un setting" }],
        };
    },
    watch: {
        jsonDataSettingLivelli: {
            handler(jsonDataSettingLivelli) {
                this.$emit("update", jsonDataSettingLivelli);
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadSettingOptions();
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonDataSettingLivelli = response.data.data;
                        this.$emit("afterLoadData");
                    })
                    .catch(() => {});
            }
        },
        loadSettingOptions() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSetting, {}, me.loadSettingOptionsSuccess, me.loadSettingOptionsError);
        },
        loadSettingOptionsSuccess(response) {
            let me = this;
            response.data.data.list.forEach((item) => {
                me.settingOptions.push({ value: item.id, text: item.setting });
            });
        },
        loadSettingOptionsError(error) {
            console.error("RsaConfigurazioneSettingLivelliEditComponent - loadSettingOptionsError", error);
        },
    },
};
</script>
